import {
    Cell,
    Legend,
    Pie,
    PieChart,
    ResponsiveContainer,
    Tooltip,
} from "recharts";
import {newReferenceFontSize} from "~/components/reports/reportConstants";
import {CustomTooltip} from "~/components/reports/widgets/donutChart";

export const PieChartCustom = ({
    data,
    baseSize,
    title,
    valuesPrefix,
    scalingFactor,
}: {
    data: Array<{name: string; value: number; color: string}>;
    title: string;
    baseSize: number;
    valuesPrefix?: string | null;
    scalingFactor: number;
}) => {
    const totalValue = data.reduce(
        (acc, dataPoint) => (acc += dataPoint.value),
        0,
    );

    return (
        <div
            className="w-full grid place-items-center"
            style={{height: "100%"}}
        >
            {/* <div
                style={{
                    fontSize: `${newReferenceFontSize * scalingFactor}px`,
                }}
            >
                {title}
            </div> */}
            <ResponsiveContainer
                width={"100%"}
                height={baseSize}
            >
                <PieChart>
                    <Pie
                        data={data}
                        dataKey={"value"}
                        nameKey={"name"}
                        blendStroke={true}
                        stroke="#000"
                        width={baseSize - newReferenceFontSize * scalingFactor}
                        height={baseSize - newReferenceFontSize * scalingFactor}
                    >
                        {data.map((dataPoint, dataPointIndex) => (
                            <Cell
                                key={`cell-${dataPointIndex}`}
                                fill={dataPoint.color}
                                className="focus:!outline-none"
                            />
                        ))}
                    </Pie>

                    <Legend
                        verticalAlign="bottom"
                        align="center"
                        wrapperStyle={{
                            bottom: "-4px",
                            fontSize: "10px",
                            maxHeight: "30%",
                            overflowY: "auto",
                            overflowX: "clip",
                            color: "#fff",
                        }}
                    />

                    <Tooltip
                        content={
                            <CustomTooltip
                                prefix={valuesPrefix}
                                totalValue={totalValue}
                            />
                        }
                    />
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
};
